<template>
  <div
    class="project-page"
  >
    <!-- 背景 -->
    <van-image
      class="abs blur-bg flanimated1s fadeIn"
      style="z-index: 0;"
      :src="require('@/imgs/index/park/park_p_cover.png')"
      :show-error="false"
      :show-loading="false"
    />
    <!-- 内容 -->
    <van-swipe
      ref="swiper"
      class="content-info-view"
      :show-indicators="false"
      :width="clientWidth"
      @change="swiperChange"
    >
      <van-swipe-item>
        <div
          class="video-view flx-col-ctr"
          :style="{width: `10rem`, height: `${bodyHeight}px`, overflow: 'hidden'}"
        >
          <video
            id="jc_video"
            :style="{width: `10rem`, height: `calc(100vh - 54px)`}"
            webkit-playsinline="true"
            x-webkit-airplay="true"
            playsinline="true"
            x5-video-player-type="h5"
            x5-video-orientation="portraint"
            x5-video-player-fullscreen="true"
            preload="auto"
            autoplay="autoplay"
            x5-playsinline="true"
            loop="loop"
            style="object-fit: fill; width: 100%; z-index: 0;position:absolute;top: 50%;transform: translateY(-50%);"
          >
            <source
              src="../../media/park_01.mp4"
              type="video/mp4"
            >
          </video>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      activeNav: 0,
      clientWidth: 0,
      bodyWidth: 0,
      bodyHeight: 0,
    };
  },
  mounted() {
    this.bodyHeight = document.documentElement.clientHeight - 84;
    this.bodyWidth = document.documentElement.clientWidth;
    // 正确设置swiper宽度
    this.clientWidth = document.body.clientWidth;
    // 自动播放
    // document.addEventListener('touchstart', () => {
    //   document.getElementById('jc_video').play();
    //   document.getElementById('jc2_video').play();
    // });
  },
  methods: {
    acNavChange(id) {
      this.activeNav = id;
      this.$refs.swiper.swipeTo(id);
    },
    swiperChange(index) {
      this.activeNav = index;
    },
  },
};
</script>

<style lang="less" scope>
// 禁止全屏
video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}
// 禁止当前播放时间
video::-webkit-media-controls-current-time-display {
  display: none !important;
}
// 禁止音量按钮
video::-webkit-media-controls-volume-control-container {
  display: none !important;
}
// 禁止剩余时间
video::-webkit-media-controls-time-remaining-display {
  display: none !important;
}
// 禁止时间轴
video::-webkit-media-controls-timeline {
  display: none !important;
}
.blur-bg {
  width: 30rem;
  filter: blur(8px);
  z-index: -1;
}
.project-page {
  position: relative;
  width: 10rem;
  height: calc(100vh - 54px);
  background-color: #fefefe;
  background-size: cover;
  overflow: hidden;
  .video-view {
    video {
      width: calc(100vh - 54px);
      height: 10rem;
      // transform: rotate(90deg);
      // transform-origin: 50% 50%;
    }
  }
  .menu-view {
    bottom: 1vh;
    width: 100%;
    height: 50px;
    padding: 5px;
    z-index: 2;
    .menu {
      padding: 6px 12px;
      background-color: #231f1d;
      border-radius: 50px;
      .icon {
        margin-right: 12px;
        line-height: 60px;
        &:last-child {
          margin: 0;
        }
      }
    }
  }
  .sub-menu-view {
    top: 21vh;
    z-index: 1;
    // background-color: rgba(0, 0, 0, .3);
    .menu {
      padding: 5px 8px;
      background-color: #212125;
    }
    .icon-view {
      margin: 3px 0;
    }
    .more {
      width: 100%;
      padding: 5px 0;
      background-color: #212125;
      margin-top: -1px;
      transition: width .5s linear;
      &.hide {
        width: 54px;
        height: 44px;
        padding: 0;
        margin-left: -22px;
        border-radius: 22px;
        & .van-image {
          margin-left: 16px;
          transform: rotate(180deg);
        }
      }
    }
  }
  .custom-indicator {
    position: absolute;
    z-index: 10;
    right: .5rem;
    top: 25vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    div {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .select-dot {
      position: absolute;
      left: 0;
      top: 54px;
      width: 10px;
      height: 10px;
      border-radius: 50px;
      background-color: #f2a434;
      transition: top .5s ease-in-out;
    }
  }
  .content-info-view,.project-swiper {
    width: 10rem;
    height: 100%;
  }
  .swiper-item {
    width: 10rem;
    height: 100%;
    .line-view {
      // height: 6vh;
      .line {
        position: relative;
        width: 8rem;
        height: 1px;
        background-color: #737373;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: -100%;
          width: 10%;
          height: 200%;
          background-color: #737373;
          border-radius: 1px;
        }
        // &::after {
        //   content: '业务模块';
        //   position: absolute;
        //   right: 0;
        //   top: -14px;
        //   font-size: 12px;
        //   font-weight: bold;
        //   height: 200%;
        //   color: #737373;
        //   border-radius: 1px;
        // }
      }
    }
  }
  .title {
    margin-top: 3vh;
  }
  .content {
    margin-top: 3vh;
  }
  .foot {
    margin-top: 4vh;
  }
}
</style>
